import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbHeading } from '../../types/pbBlocks';
import { getAdvanced, getHeadingType, parseStyleString } from '../utils';

export type HeadingType = ContentTypeObject & PbHeading;

/**
 * Aggregates the configuration of a heading element.
 * @param node
 */
export function headingConfigAggregator(node: CustomHtmlElement): HeadingType {
    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        headingType: getHeadingType(node.rawTagName),
        text: node.textContent,
        uniqueID: node.attributes['data-pb-style'],
    };
}
